const headline2 = (data) => {
  const node = data.node;
  const title = node.title;
  const serial = data.num;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "xzbreflFTW",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 921.410813648294,
        top: 24.1145406824147,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Vj2vSfFZKc",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 934.9976902887139,
        top: 24.1145406824147,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "bUmUtYy35J",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 949.1822572178478,
        top: 24.1145406824147,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "lwq3BCojS_",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 962.7690288713911,
        top: 24.1145406824147,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "P_hNvuOHne",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 921.410813648294,
        top: 37.08524934383202,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Q4XsES-OfR",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 934.9976902887139,
        top: 37.08524934383202,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "0I5JjoUDN-",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 949.1822572178478,
        top: 37.08524934383202,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "z1l_SZmAi9",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 962.7690288713911,
        top: 37.08524934383202,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "W0vyoslvkp",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 28.292178477690292,
        top: 515.1234645669291,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "mHvir9jtQ4",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 41.87905511811024,
        top: 515.1234645669291,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "G1AeTR4tuR",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 56.0636220472441,
        top: 515.1234645669291,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "69Qor1O2P0",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 69.6503937007874,
        top: 515.1234645669291,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "gc4D6PiahG",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 28.292178477690292,
        top: 528.0940682414698,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "YUl-gqL6ez",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 41.87905511811024,
        top: 528.0940682414698,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "QmtPRkQcBn",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 56.0636220472441,
        top: 528.0940682414698,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "4HhCu3KC5B",
        width: 7.970708661417323,
        height: 7.970708661417323,
        left: 69.6503937007874,
        top: 528.0940682414698,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "kxq0YAn2Uy",
        width: 0,
        height: 0,
        left: 0,
        top: 0,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "#effffd",
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "UsywOCRYik",
        width: 790.7503412073492,
        height: 76.25,
        left: 104.62477690288713,
        top: 322.8609973753281,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><span style="font-size: 37.5px;font-family: Microsoft Yahei;">${title}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "Xpm1QSqjpd",
        width: 790.7503412073492,
        height: 104.375,
        left: 104.62477690288713,
        top: 152.70299212598425,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><span style="font-size: 56.25px;font-family: Microsoft Yahei;">${serial}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "line",
        id: "V-CHNUtVhU",
        width: 1.5,
        left: 592.8839895013124,
        top: 105.308031496063,
        start: [0, 0],
        end: [81.55254593175853, 68.71559055118111],
        style: "solid",
        color: `${color}`,
        points: ["", ""],
      },
      {
        type: "line",
        id: "DORqbq944e",
        width: 0.75,
        left: 324.2461942257218,
        top: 229.52451443569552,
        start: [0, 0],
        end: [81.55254593175853, 68.71559055118111],
        style: "solid",
        color: `${color}`,
        points: ["", ""],
      },
    ],
    background: {
      type: "solid",
      color: `#fff`,
    },
  };
};

export default headline2;
